import React from 'react';
import { Box, Typography } from '@mui/material';

type InfoItemProps = {
  label: string;
  value: string | React.ReactNode;
  variant?: 'body1' | 'body2';
  valueProps?: React.ComponentProps<typeof Typography>;
};

const InfoItem: React.FC<InfoItemProps> = ({
  label,
  value,
  variant = 'body2',
  valueProps
}) => (
  <Box sx={{ mb: 0.5 }}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ fontSize: '0.7rem' }}
    >
      {label}
    </Typography>
    {typeof value === 'string' ? (
      <Typography
        variant={variant}
        sx={{ fontWeight: 500, lineHeight: 1.25 }}
        {...valueProps}
      >
        {value || '—'}
      </Typography>
    ) : (
      <Box
        sx={{
          fontWeight: 500,
          lineHeight: 1.25,
          fontSize: variant === 'body1' ? '1rem' : '0.875rem'
        }}
      >
        {value || '—'}
      </Box>
    )}
  </Box>
);

export default InfoItem;
